import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [settings, setSettings] = useState(null);

  const loadSettings = useCallback(() => api.get("/settings").then((r) => setSettings(r.data)), []);
  const scoped = settings && user ? { ...settings, my_cost_centers: settings.cost_centers.filter((c) => (user._ccs ? user._ccs.includes(c.code) : (user._companies || []).includes(c.company))) } : settings;

  useEffect(() => {
    if (!localStorage.getItem("dcf_token")) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  useEffect(() => {
    if (user) loadSettings();
  }, [user, loadSettings]);

  const loginWithToken = async (token) => {
    localStorage.setItem("dcf_token", token);
    const r = await api.get("/auth/me");
    setUser(r.data);
  };
  const refreshUser = useCallback(() => api.get("/auth/me").then((r) => setUser(r.data)), []);
  const logout = () => {
    localStorage.removeItem("dcf_token");
    localStorage.removeItem("dcf_admin_token");
    setUser(false);
  };
  const impersonate = (token) => {
    localStorage.setItem("dcf_admin_token", localStorage.getItem("dcf_token"));
    localStorage.setItem("dcf_token", token);
    localStorage.removeItem("dcf_company");
    window.location.href = "/";
  };
  const stopImpersonation = () => {
    localStorage.setItem("dcf_token", localStorage.getItem("dcf_admin_token"));
    localStorage.removeItem("dcf_admin_token");
    localStorage.removeItem("dcf_company");
    window.location.href = "/administration";
  };
  return <AuthCtx.Provider value={{ user, settings: scoped, loadSettings, refreshUser, loginWithToken, logout, impersonate, stopImpersonation }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
